import imageCompression from 'browser-image-compression'
import heic2any from 'heic2any'

export const processImage = async (file: File): Promise<File> => {
  try {
    let processedFile = file

    // HEICファイルの場合、まずcreateImageBitmapを試し、失敗したらJPEGに変換
    if (
      file.type === 'image/heic' ||
      file.type === 'image/heif'
    ) {
      try {
        // FileをBlobとして読み込む
        const blob = new Blob([await file.arrayBuffer()], { type: file.type })
        
        // createImageBitmapを試みる
        const bitmap = await createImageBitmap(blob).catch(e => {
          throw e // 失敗したら例外を投げて次の処理へ
        })
        
        // Canvasに描画してJPEGに変換
        const canvas = document.createElement('canvas')
        canvas.width = bitmap.width
        canvas.height = bitmap.height
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          throw new Error('Failed to get canvas context')
        }
        ctx.drawImage(bitmap, 0, 0)
        
        // CanvasからBlobを取得
        const jpegBlob = await new Promise<Blob>(resolve => {
          canvas.toBlob(blob => {
            if (!blob) {
              throw new Error('Failed to convert canvas to Blob')
            }
            resolve(blob)
          })
        })
        
        processedFile = new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpg'), {
          type: 'image/jpeg',
        })
        
      } catch {
        const jpegBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.9,
        })

        // HEIC画像はモーションが含まれている場合があるため、配列として返されることがある
        processedFile = new File([Array.isArray(jpegBlob) ? jpegBlob[0] : jpegBlob], file.name.replace(/\.heic$/i, '.jpg'), {
          type: 'image/jpeg',
        })
      }
    }

    // jpegに変換して圧縮
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 2000,
      useWebWorker: true,
      fileType: 'image/jpeg',
    }

    const compressedFile = await imageCompression(processedFile, options)

    // ファイル名の拡張子をjpegに変更
    const jpegFile = new File([compressedFile], file.name.replace(/\.[^/.]+$/, '.jpg'), {
      type: 'image/jpeg',
    })

    return jpegFile
  } catch {
    return file // エラー時は元のファイルを返す
  }
}

// ファイルをBase64に変換する関数
export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}
